import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Panel from 'components/Panel';
export function SendButtonPanel(_ref) {
  var isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    icon: "send",
    isDisabled: isDisabled
  }, t('actions_share')));
}
export default SendButtonPanel;